import type { UnknownCallback } from "@/types";

export const handleToolbarEvent = (
  event: React.MouseEvent<HTMLElement>,
  eventHandler: UnknownCallback
) => {
  if (!event || !eventHandler) {
    return;
  }

  event.stopPropagation();
  eventHandler();
};
